import * as z from 'zod';

export const ConnectWixPaymentsAccountRequest = z.object({
  account: z
    .object({
      _id: z
        .string()
        .describe('ID of the Wix Payments account.')
        .regex(
          /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
          'Must be a valid GUID'
        )
        .optional()
        .nullable(),
      firstName: z
        .string()
        .describe('First name of the Wix Payments account owner.')
        .max(500),
      lastName: z
        .string()
        .describe('Last name of the Wix Payments account owner.')
        .max(500),
      tosAccepted: z
        .boolean()
        .describe(
          "Whether the account owner has accepted the\n[Wix Payments Terms of Service](https://www.wix.com/about/terms-of-payments).\nThe account owner must accept these terms for the account to be created\nsuccessfully. If the terms aren't accepted, the Connect Wix Payments Account\ncall fails."
        ),
      termsOfServiceAcceptance: z
        .object({ ip: z.string().max(45).optional() })
        .optional(),
      email: z
        .string()
        .describe('email of the Wix Payments account owner.')
        .email()
        .optional()
        .nullable(),
      productDescription: z
        .string()
        .describe(
          'Brief summary of the types of products and services offered for sale through the Wix Payments account.\nFor example, "Sportswear and sport accessories".'
        )
        .max(500)
        .optional()
        .nullable(),
      country: z.string().describe('Country code.').optional().nullable(),
      softDescriptor: z.string().max(50).optional().nullable(),
      businessUrl: z.string().url().optional().nullable(),
    })
    .describe('Wix Payments account to connect to the site.'),
});
export const ConnectWixPaymentsAccountResponse = z.object({
  account: z
    .object({
      _id: z
        .string()
        .describe('ID of the Wix Payments account.')
        .regex(
          /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
          'Must be a valid GUID'
        )
        .optional()
        .nullable(),
      firstName: z
        .string()
        .describe('First name of the Wix Payments account owner.')
        .max(500)
        .optional()
        .nullable(),
      lastName: z
        .string()
        .describe('Last name of the Wix Payments account owner.')
        .max(500)
        .optional()
        .nullable(),
      tosAccepted: z
        .boolean()
        .describe(
          "Whether the account owner has accepted the\n[Wix Payments Terms of Service](https://www.wix.com/about/terms-of-payments).\nThe account owner must accept these terms for the account to be created\nsuccessfully. If the terms aren't accepted, the Connect Wix Payments Account\ncall fails."
        )
        .optional()
        .nullable(),
      termsOfServiceAcceptance: z
        .object({ ip: z.string().max(45).optional() })
        .optional(),
      email: z
        .string()
        .describe('email of the Wix Payments account owner.')
        .email()
        .optional()
        .nullable(),
      productDescription: z
        .string()
        .describe(
          'Brief summary of the types of products and services offered for sale through the Wix Payments account.\nFor example, "Sportswear and sport accessories".'
        )
        .max(500)
        .optional()
        .nullable(),
      country: z.string().describe('Country code.').optional().nullable(),
      softDescriptor: z.string().max(50).optional().nullable(),
      businessUrl: z.string().url().optional().nullable(),
    })
    .describe('Connected Wix Payments account.')
    .optional(),
});
export const ConnectWixPaymentsAccountBase44Request = z.object({
  account: z
    .object({
      _id: z
        .string()
        .describe('ID of the Wix Payments account.')
        .regex(
          /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
          'Must be a valid GUID'
        )
        .optional()
        .nullable(),
      firstName: z
        .string()
        .describe('First name of the Wix Payments account owner.')
        .max(500),
      lastName: z
        .string()
        .describe('Last name of the Wix Payments account owner.')
        .max(500),
      tosAccepted: z
        .boolean()
        .describe(
          "Whether the account owner has accepted the\n[Wix Payments Terms of Service](https://www.wix.com/about/terms-of-payments).\nThe account owner must accept these terms for the account to be created\nsuccessfully. If the terms aren't accepted, the Connect Wix Payments Account\ncall fails."
        )
        .optional()
        .nullable(),
      termsOfServiceAcceptance: z.object({ ip: z.string().max(45).optional() }),
      email: z
        .string()
        .describe('email of the Wix Payments account owner.')
        .email(),
      productDescription: z
        .string()
        .describe(
          'Brief summary of the types of products and services offered for sale through the Wix Payments account.\nFor example, "Sportswear and sport accessories".'
        )
        .max(500)
        .optional()
        .nullable(),
      country: z.string().describe('Country code.').optional().nullable(),
      softDescriptor: z.string().max(50).optional().nullable(),
      businessUrl: z.string().url().optional().nullable(),
    })
    .describe('Wix Payments account to connect to the site.'),
  options: z
    .object({
      siteId: z
        .string()
        .describe('MetaSite id')
        .regex(
          /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
          'Must be a valid GUID'
        )
        .optional()
        .nullable(),
      userId: z
        .string()
        .describe('User id')
        .regex(
          /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
          'Must be a valid GUID'
        )
        .optional()
        .nullable(),
      appId: z.string().describe('App id').max(32).optional().nullable(),
      base44App: z
        .object({
          appId: z.string().describe('App id').max(32).optional().nullable(),
          appName: z
            .string()
            .describe('App name')
            .max(512)
            .optional()
            .nullable(),
          appUrl: z.string().describe('App url').url().optional().nullable(),
          ownerEmail: z
            .string()
            .describe('email of the Base app owner.')
            .email()
            .optional()
            .nullable(),
          country: z.string().describe('Country code.').optional().nullable(),
        })
        .optional(),
    })
    .optional(),
});
export const ConnectWixPaymentsAccountBase44Response = z.object({
  account: z
    .object({
      _id: z
        .string()
        .describe('ID of the Wix Payments account.')
        .regex(
          /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
          'Must be a valid GUID'
        )
        .optional()
        .nullable(),
      firstName: z
        .string()
        .describe('First name of the Wix Payments account owner.')
        .max(500)
        .optional()
        .nullable(),
      lastName: z
        .string()
        .describe('Last name of the Wix Payments account owner.')
        .max(500)
        .optional()
        .nullable(),
      tosAccepted: z
        .boolean()
        .describe(
          "Whether the account owner has accepted the\n[Wix Payments Terms of Service](https://www.wix.com/about/terms-of-payments).\nThe account owner must accept these terms for the account to be created\nsuccessfully. If the terms aren't accepted, the Connect Wix Payments Account\ncall fails."
        )
        .optional()
        .nullable(),
      termsOfServiceAcceptance: z
        .object({ ip: z.string().max(45).optional() })
        .optional(),
      email: z
        .string()
        .describe('email of the Wix Payments account owner.')
        .email()
        .optional()
        .nullable(),
      productDescription: z
        .string()
        .describe(
          'Brief summary of the types of products and services offered for sale through the Wix Payments account.\nFor example, "Sportswear and sport accessories".'
        )
        .max(500)
        .optional()
        .nullable(),
      country: z.string().describe('Country code.').optional().nullable(),
      softDescriptor: z.string().max(50).optional().nullable(),
      businessUrl: z.string().url().optional().nullable(),
    })
    .describe('Connected Wix Payments account.')
    .optional(),
  base44Metadata: z
    .object({
      siteId: z
        .string()
        .describe('MetaSite ID')
        .regex(
          /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
          'Must be a valid GUID'
        )
        .optional(),
      webhookPublicKey: z
        .string()
        .describe('Webhook public key for verifying callbacks')
        .max(500)
        .optional(),
      appSecret: z
        .string()
        .describe('App secret for authentication')
        .max(500)
        .optional(),
      apiKey: z
        .string()
        .describe('API key for subsequent calls')
        .max(500)
        .optional(),
    })
    .optional(),
});
export const SetupBase44SiteRequest = z.object({
  options: z
    .object({
      siteId: z
        .string()
        .describe('MetaSite ID. If not provided, a new metasite is created.')
        .regex(
          /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
          'Must be a valid GUID'
        )
        .optional()
        .nullable(),
      userId: z
        .string()
        .describe(
          'User ID. If not provided, extracted from the authentication token.'
        )
        .regex(
          /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
          'Must be a valid GUID'
        )
        .optional()
        .nullable(),
      appId: z.string().describe('App ID').max(32).optional().nullable(),
      base44App: z
        .object({
          appId: z.string().describe('App id').max(32).optional().nullable(),
          appName: z
            .string()
            .describe('App name')
            .max(512)
            .optional()
            .nullable(),
          appUrl: z.string().describe('App url').url().optional().nullable(),
          ownerEmail: z
            .string()
            .describe('email of the Base app owner.')
            .email()
            .optional()
            .nullable(),
          country: z.string().describe('Country code.').optional().nullable(),
        })
        .describe('Base44 app data')
        .optional(),
    })
    .optional(),
});
export const SetupBase44SiteResponse = z.object({
  siteId: z
    .string()
    .describe('MetaSite ID of the created or existing site')
    .regex(
      /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
      'Must be a valid GUID'
    )
    .optional(),
  apiKey: z
    .string()
    .describe('API key for subsequent calls')
    .max(500)
    .optional(),
});
